// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Date-module__date___hqaKJ{font-size:12px;white-space:nowrap;color:hsla(0,0%,100%,.5)}", "",{"version":3,"sources":["webpack://./src/features/sense/ui/components/Date/Date.module.scss"],"names":[],"mappings":"AAAA,2BACE,cAAA,CACA,kBAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": "Date-module__date___hqaKJ"
};
export default ___CSS_LOADER_EXPORT___;
